import axios from "axios";
import Globais, { validateToken } from "../../components/Globais";
import { useEffect, useState } from "react";

export const usePermissaoCotaUsuario = (cotaUsuarioId: number) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isValid, setIsValid] = useState<boolean>(false);

  useEffect(() => {
    const verificar = async () => {
      const Token = validateToken();

      if (!Token) {
        setIsValid(false);
        setIsLoading(false);
        return;
      }

      try {
        if(Token.nda === 1 || Token.nda === 2){
          setIsValid(true);

        }else{
          const url = `${Globais.DOMINIOBACK}/cota-usuario/${cotaUsuarioId}`;
        const response = await axios.get(url, {
          headers: { Authorization: Token.AuthStr },
        });

        const usuarioIdDaCota = Number(response.data.usuarioId);
        const usuarioIdToken = Number(Token.id);

        
        console.log("usuarioIdDaCota =", usuarioIdDaCota, typeof usuarioIdDaCota);
        console.log("usuarioIdToken =", usuarioIdToken, typeof usuarioIdToken);
        console.log("Comparação =", usuarioIdDaCota === usuarioIdToken);

        setIsValid(usuarioIdDaCota === usuarioIdToken);

        }
        

      } catch (error) {
        setIsValid(false);
      }

      setIsLoading(false);
    };

    verificar();
  }, [cotaUsuarioId]);

  return { isLoading, isValid };
};

